export default __webpack_public_path__ + "static/media/Cattura1.709df65a.jpg";